export default __webpack_public_path__ + "static/media/boot.ef9b8aa6.png";